export enum MessagesEvents {
  MessagesClick = 'messages_click',
}
